function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 11.2H11A1.8 1.8 0 009.2 13v6a1.8 1.8 0 001.8 1.8h10a1.8 1.8 0 001.8-1.8v-6a1.8 1.8 0 00-1.8-1.8zM11 10a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3v-6a3 3 0 00-3-3H11z",
  fill: "#999"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.5 14.6H9v-1.2h14.5v1.2z",
  fill: "#999"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.25 16a.5.5 0 01.5-.5h1.5a.5.5 0 01.5.5v.5a.5.5 0 01-.5.5h-1.5a.5.5 0 01-.5-.5V16z",
  fill: "#999"
});

var SvgIconAimateCreditCard = function SvgIconAimateCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMSAxMS4ySDExQzEwLjAwNTkgMTEuMiA5LjIgMTIuMDA1OSA5LjIgMTNWMTlDOS4yIDE5Ljk5NDEgMTAuMDA1OSAyMC44IDExIDIwLjhIMjFDMjEuOTk0MSAyMC44IDIyLjggMTkuOTk0MSAyMi44IDE5VjEzQzIyLjggMTIuMDA1OSAyMS45OTQxIDExLjIgMjEgMTEuMlpNMTEgMTBDOS4zNDMxNSAxMCA4IDExLjM0MzEgOCAxM1YxOUM4IDIwLjY1NjkgOS4zNDMxNSAyMiAxMSAyMkgyMUMyMi42NTY5IDIyIDI0IDIwLjY1NjkgMjQgMTlWMTNDMjQgMTEuMzQzMSAyMi42NTY5IDEwIDIxIDEwSDExWiIgZmlsbD0iIzk5OTk5OSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIzLjUgMTQuNkg5VjEzLjRIMjMuNVYxNC42WiIgZmlsbD0iIzk5OTk5OSIvPgo8cGF0aCBkPSJNMTAuMjUgMTZDMTAuMjUgMTUuNzIzOSAxMC40NzM5IDE1LjUgMTAuNzUgMTUuNUgxMi4yNUMxMi41MjYxIDE1LjUgMTIuNzUgMTUuNzIzOSAxMi43NSAxNlYxNi41QzEyLjc1IDE2Ljc3NjEgMTIuNTI2MSAxNyAxMi4yNSAxN0gxMC43NUMxMC40NzM5IDE3IDEwLjI1IDE2Ljc3NjEgMTAuMjUgMTYuNVYxNloiIGZpbGw9IiM5OTk5OTkiLz4KPC9zdmc+Cg==";
export { SvgIconAimateCreditCard as ReactComponent };